import HBIcon from "@/components/HBIcon";
import useAppStore from "@/context/store";
import FromDialog, { LeadsEntrance } from "@/pageComponents/Consult/FormModal";
import { getGrocery } from "@/services";
import useReq from "@/utils/useReq";
import { Collapse, Popover, Table } from "antd";
import classNames from "classnames";
import { isArray, isUndefined } from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import { Case, Switch } from "react-if";
import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";
const { Panel } = Collapse;

export enum MaterialAuthType {
  /**线上授权 */
  online,
  /**线下授权 */
  offline,
  /**定制授权 */
  custom,
}

export function MaterialAuthTable({
  data,
  className,
  activeKey,
  isModal,
  title,
  onCloseModal,
}: {
  data: any;
  className?: string;
  activeKey?: string | string[];
  isModal?: boolean;
  title?: string;
  onCloseModal?: () => void;
}) {
  const { headerHeight, user, vips } = useAppStore(
    ({ headerHeight, user, vips }) => ({
      headerHeight,
      user,
      vips,
    })
  );
  const collapseRef = useRef(null);
  const [showHeader, setShowHeader] = useState(false);
  const defaultActiveKey = useMemo(() => {
    if (!isUndefined(activeKey)) {
      return isArray(activeKey) ? activeKey : [activeKey];
    }
    return data?.auth?.map?.((_, index) => index);
  }, [activeKey, data]);

  useEffect(() => {
    if (isModal) {
      const target = collapseRef.current.children[0];

      const onScroll = () => {
        setShowHeader(target.scrollTop > 0);
      };

      target.addEventListener("scroll", onScroll, {
        passive: true,
      });

      return () => {
        // window.removeEventListener("scroll", onScroll);
        target.removeEventListener("scroll", onScroll);
      };
    }

    const onScroll = () => {
      const rect = collapseRef.current?.getBoundingClientRect();
      setShowHeader(
        rect?.top - headerHeight - 114 <= 0 &&
          rect?.bottom - headerHeight - 114 >= 0
      );
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [headerHeight, isModal]);

  const authTableColumns = useMemo(() => {
    const renderColumns = (text) => {
      return (
        <div className={styles.icon}>
          <Switch>
            <Case condition={text === "true"}>
              <HBIcon className={styles.checked} type="ic_check" />
            </Case>
            <Case condition={text === "false"}>
              <HBIcon className={styles.unchecked} type="ic_close" />
            </Case>
            <Case condition={text}>
              <div className={styles.text}>{text}</div>
            </Case>
          </Switch>
        </div>
      );
    };

    const columns = data.tableHeader.map((item) => {
      return {
        ...item,
        dataIndex: item.key,
        width: +item.width || item.width,
        render: renderColumns,
      };
    });

    return [
      {
        title: "授权描述",
        dataIndex: "desc",
        key: "desc",
        render: (text) => {
          return <div className={styles.title}>{text}</div>;
        },
      },

      ...columns,
    ];
  }, [data]);

  return (
    <div className={classNames([styles.auth, className])}>
      <div className={styles.wrapper}>
        <div
          className={classNames([
            styles.sticky,
            isModal ? null : "modalOpenWidth",
            showHeader ? styles.active : null,
          ])}
          style={{
            top: `${isModal ? 0 : headerHeight}px`,
            position: isModal ? "absolute" : "fixed",
          }}
        >
          <div className={styles.container}>
            <div className={styles.col}>
              <div className={styles.desc}>{title || "授权范围对比"}</div>
            </div>
            {data.tableHeader.map((item, index) => {
              if (data.tableHeader.length - 1 === index) {
                return (
                  <div className={classNames([styles.col, styles.fixed])}>
                    <div className={styles.title}>{item.title}</div>
                    <div className={styles.subtitle}>{item.subTitle}</div>
                    <a
                      data-gd-click="button_click"
                      data-button-name="免费咨询"
                      className={classNames([styles.button, styles.text])}
                      href={`/vip/consult?leads_entrance=${LeadsEntrance.Other}`}
                      target="_blank"
                      onClick={async (e) => {
                        // 弹窗模式下
                        if (isModal) {
                          // 关闭当前弹窗
                          onCloseModal();
                          e.preventDefault();
                          const config = await getGrocery("company-consult-v2");
                          FromDialog.open({
                            config,
                            leads_entrance: LeadsEntrance.PinDetailAuthDialog,
                          });
                        }
                      }}
                    >
                      免费咨询
                    </a>
                  </div>
                );
              }

              return (
                <div
                  className={classNames([styles.col, styles.fixed])}
                  key={index}
                >
                  <div className={styles.title}>{item.title}</div>
                  <div
                    className={styles.subtitle}
                    style={{
                      marginTop: 12,
                    }}
                  >
                    {item.subTitle}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.header}>
          <div className={styles.col}>
            <div className={styles.desc}>{title || "授权范围对比"}</div>
          </div>
          {data.tableHeader.map((item, index) => {
            // 最后一个大企业定制
            if (index === data.tableHeader.length - 1) {
              return (
                <div
                  key={item.key}
                  className={classNames([styles.col, styles.fixed])}
                >
                  <div className={styles.title}>{item.title}</div>
                  <a
                    className={styles.button}
                    href={`/vip/consult?leads_entrance=${LeadsEntrance.Other}`}
                    target="_blank"
                    onClick={async (e) => {
                      if (isModal) {
                        // 关闭当前弹窗
                        onCloseModal();
                        e.preventDefault();
                        const config = await getGrocery("company-consult-v2");
                        FromDialog.open({
                          config,
                          leads_entrance: LeadsEntrance.PinDetailAuthDialog,
                        });
                      }
                    }}
                    data-gd-click="button_click"
                    data-button-name="免费咨询"
                  >
                    免费咨询
                  </a>
                </div>
              );
            }

            return (
              <div
                key={item.key}
                className={classNames([styles.col, styles.fixed])}
              >
                <div className={styles.title}>{item.title}</div>
                <div className={styles.subtitle}>
                  <div className={styles.text}>{item.subTitle}</div>
                  {item.authTip && (
                    <Popover
                      content={
                        <div
                          className={styles.tipText}
                          dangerouslySetInnerHTML={{ __html: item?.authTip }}
                        ></div>
                      }
                      placement="top"
                    >
                      <HBIcon className={styles.icon} type="ic_help" />
                    </Popover>
                  )}
                </div>
              </div>
            );
          })}
        </div>
        <div ref={collapseRef}>
          <Collapse
            className={styles.collapse}
            destroyInactivePanel={true}
            defaultActiveKey={defaultActiveKey}
            expandIcon={() => (
              <HBIcon className={styles.arrow} type="ic_chevron_right" />
            )}
          >
            {data?.auth?.map((item, index) => (
              <Panel header={item?.title} key={index}>
                <Table
                  className={styles.table}
                  rowKey="id"
                  dataSource={item?.list}
                  columns={authTableColumns}
                  pagination={false}
                  showHeader={false}
                />
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </div>
  );
}

export function MaterialAuthTableDialogRaw(props) {
  const { category, activeKey, ...rest } = props;

  const { data } = useReq(async () => {
    const conf = await getGrocery("hb-material-auth-table");
    return conf[category] || conf["图片"];
  });

  if (!data) {
    return null;
  }

  return (
    <HBModal
      className={styles.dialog}
      width={1200}
      {...rest}
      bodyStyle={{ padding: 0 }}
      footer={null}
      data-content-source={"授权范围弹窗"}
    >
      <MaterialAuthTable
        data={data}
        title={data.title}
        activeKey={props.activeKey}
        isModal
        onCloseModal={rest.onCancel}
      />
    </HBModal>
  );
}

export const MaterialAuthTableDialog = ModalWrap(MaterialAuthTableDialogRaw, {
  unique: true,
});
